import { render, staticRenderFns } from "./errornich.vue?vue&type=template&id=dc503142"
import script from "./errornich.vue?vue&type=script&lang=js"
export * from "./errornich.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports